// src/customer-form/SubjectField.jsx
const subjectLabels = { en: 'Subject', fr: 'Objet', ar: 'الموضوع' };

function getLanguage(country) {
  if (country === 'Morocco') return 'ar';
  if (country === 'Senegal' || country === "Cote D'ivoire") return 'fr';
  return 'en';
}

export default function SubjectField({ formData, handleChange, handleBlur, errors = {}, touched = {} }) {
  const lang = getLanguage(formData.country);
  return (
    <div className={`field ${touched.subject && errors.subject ? 'has-error' : ''}`}>
      <label className="label">{subjectLabels[lang]} <span className="required">*</span></label>
      {touched.subject && errors.subject && <div className="error-message">{errors.subject}</div>}
      <input className="input" name="subject" value={formData.subject} onChange={handleChange} onBlur={handleBlur} required />
    </div>
  );
}
